<template>
  <section :class="$style.page">
    <header :class="[$style.page__header, $style.header]">
      <img
        src="@/assets/images/logo.svg?url"
        :class="[$style.header__logo, $style.logo]"
      />
      <h1 :class="[$style.header__status, $style.status]">
        <span :class="$style.status__code">
          {{ statusCode }}
        </span>
        <span :class="$style.status__message">
          {{ statusCodeMessage }}
        </span>
      </h1>
    </header>
    <OkanekoImage :class="$style.page__okaneko" />
    <p :class="$style.page__body">
      <slot />
    </p>
    <footer :class="$style.page__footer">
      <FlatRouterLinkButton
        variant="plain"
        size="medium"
        :class="$style.button"
        :to="{ path: '/' }"
      >
        ダッシュボードに戻る
      </FlatRouterLinkButton>
    </footer>
  </section>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import OkanekoImage from '@/assets/images/okaneko-error.svg?component'
import { getErrorMessageFromCode } from '@/libs/utilities/statusCode'
import FlatRouterLinkButton from '@/components/atoms/FlatRouterLinkButton.vue'

export default defineComponent({
  name: 'ErrorPageBase',
  components: {
    OkanekoImage,
    FlatRouterLinkButton,
  },
  props: {
    statusCode: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const statusCodeMessage = computed(
      (): string =>
        getErrorMessageFromCode(props.statusCode) ?? 'Something went wrong'
    )
    return {
      statusCodeMessage,
    }
  },
})
</script>

<style lang="scss" module>
.page {
  &__okaneko {
    display: block;
    width: 204px;
    margin-right: auto;
    margin-left: auto;

    &:nth-child(n + 2) {
      margin-top: 40px;
    }
  }

  &__body {
    text-align: center;

    &:nth-child(n + 2) {
      margin-top: 40px;
    }
  }

  &__footer {
    font-size: 14px;
    text-align: center;

    &:nth-child(n + 2) {
      margin-top: 40px;
    }
  }
}

.header {
  &__status {
    &:nth-child(n + 2) {
      margin-top: 36px;
    }
  }
}

.logo {
  display: block;
  width: 320px;
  margin-right: auto;
  margin-left: auto;
}

.status {
  color: $color-text-and-object-accent-primary;
  text-align: center;

  &__code {
    display: block;
    font-size: 100px;
    font-weight: bold;
    line-height: 82px;
  }

  &__message {
    display: block;
    font-size: 20px;
    font-weight: normal;
    line-height: 1;

    &:nth-child(n + 2) {
      margin-top: 20px;
    }
  }
}

.body {
  font-size: 16px;
  line-height: 28px;
}

.button {
  display: inline-flex;
  height: 40px;
  align-items: center;
  padding-right: 2em;
  padding-left: 2em;
  font-size: 14px;
  text-align: center;
}
</style>
